import { i as isString$1 } from '../is-string/index.js';
import { i as isNumberObject } from '../is-number-object/index.js';
import { i as isBooleanObject } from '../is-boolean-object/index.js';
import '../is-symbol/index.js';
import '../is-bigint/index.js';
import { i as isSymbol$1 } from '../../_vendor/is-symbol/index.js_commonjs-module.js';
import { i as isBigint } from '../../_vendor/is-bigint/index.js_commonjs-module.js';

var isString = isString$1;
var isNumber = isNumberObject;
var isBoolean = isBooleanObject;
var isSymbol = isSymbol$1.exports;
var isBigInt = isBigint.exports;

// eslint-disable-next-line consistent-return
var whichBoxedPrimitive = function whichBoxedPrimitive(value) {
	// eslint-disable-next-line eqeqeq
	if (value == null || (typeof value !== 'object' && typeof value !== 'function')) {
		return null;
	}
	if (isString(value)) {
		return 'String';
	}
	if (isNumber(value)) {
		return 'Number';
	}
	if (isBoolean(value)) {
		return 'Boolean';
	}
	if (isSymbol(value)) {
		return 'Symbol';
	}
	if (isBigInt(value)) {
		return 'BigInt';
	}
};

export { whichBoxedPrimitive as w };
